<template>
  <div>
    <el-dialog
      title="更新历史"
      visible
      :close-on-click-modal="false"
      width="980px"
      :before-close="close"
      append-to-body
      custom-class="winner-workflow public-update-history"
    >
      <div class="dailog-form-item">
        <div class="public-searchForm">
          <el-form
            ref="searchForm"
            :model="searchForm"
            labelWidth="80px"
            size="mini"
          >
            <el-form-item
              prop="createBy"
              label="操作人"
            >
              <el-input
                v-model.trim="searchForm.createBy"
                clearable
                placeholder="请输入操作人"
              />
            </el-form-item>
            <el-form-item
              prop="createTimeList"
              label="操作时间"
            >
              <el-date-picker
                v-model="searchForm.createTimeList"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item
              prop="type"
              label="操作类型"
            >
              <el-select
                v-model.trim="searchForm.type"
                clearable
                placeholder="请选择操作类型"
              >
                <el-option
                  v-for="item in typeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              prop="version"
              label="操作版本"
            >
              <el-input
                v-model.number="searchForm.version"
                clearable
                placeholder="请输入操作版本"
              />
            </el-form-item>
            <el-form-item
              prop="description"
              label="操作描述"
            >
              <el-input
                v-model.trim="searchForm.description"
                clearable
                placeholder="请输入操作描述"
              />
            </el-form-item>
            <el-form-item>
              <div style="text-align: right">
                <el-button
                  type="default"
                  @click="reset"
                >
                  重置
                </el-button>
                <el-button
                  type="primary"
                  @click="search"
                >
                  查询
                </el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="public-table">
          <el-table
            ref="tableData"
            :data="tableData"
            height="300px"
            border
          >
            <template v-for="item in tableCol">
              <el-table-column
                :key="item.key"
                :prop="item.key"
                :label="item.label"
                :minWidth="item.minWidth"
              />
            </template>
            <el-table-column
              v-if="!hideHandle"
              label="操作"
              width="80"
              fixed="right"
            >
              <div
                slot-scope="scope"
                class="public-form-table-item-operate"
              >
                <a
                  title="覆盖查看"
                  @click="rollBack(scope.row)"
                >覆盖查看</a>
              </div>
            </el-table-column>
          </el-table>
          <div class="public-pagination">
            <WPagination
              v-model="page"
              @change="query"
            />
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="close">
          关 闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    id: {
      required: true,
      type: String,
      default: ''
    },
    hideHandle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      page: {},
      searchForm: {
        createBy: '',
        createTimeList: [],
        type: '',
        version: '',
        description: ''
      },
      selectParam: {},
      tableData: [],
      tableCol: [
        { label: '操作人', key: 'createByView', minWidth: 100 },
        { label: '操作时间', key: 'createTime', minWidth: 150 },
        { label: '操作类型', key: '_type', minWidth: 80 },
        { label: '操作版本', key: 'version', minWidth: 80 },
        { label: '操作描述', key: 'description', minWidth: 220 }
      ],
      typeList: [
        { label: '部署', value: 'deploy' },
        { label: '更新', value: 'update' },
        { label: '回滚', value: 'rollback' }
      ],
      typeMap: {
        deploy: '部署',
        update: '更新',
        rollback: '回滚'
      }
    }
  },
  created() {
    this.search()
  },
  methods: {
    reset() {
      this.$refs.searchForm.resetFields()
      this.search()
    },
    search() {
      this.page.current = 1
      this.page.size = 10
      this.selectParam = { ...this.searchForm }
      this.query()
    },
    query() {
      const { current = 1, size = 10 } = this.page
      this.$api.formAssembly.updateHistory({
        pageParam: { current, size },
        selectParam: {
          ...this.selectParam,
          assemblyId: this.id
        }
      }).then(data => {
        data.records.forEach(item => {
          item._type = this.typeMap[item.type] || ''
        })
        this.tableData = data.records
        this.page.total = data.total
      })
    },
    rollBack(row) {
      const info = '<p>确定覆盖当前开发数据？</p><p>覆盖并点击保存才会保存数据！</p>'
      this.$confirm(info, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(() => {
        this.$emit('close')
        this.$emit('rollBack', row)
      }).catch(() => {})
    },
    close() {
      this.$emit('close')
    }
  }
}

</script>
<style lang="scss">
.public-update-history {
  .el-dialog__body {
    padding-top: 10px;
  }

  .rollback-version {
    color: #F56C6C;
  }

  .public-searchForm {
    .el-form-item {
      display: inline-block;
      width: 33.33%;
      margin-right: 0;
    }

    .el-input,
    .el-select,
    .el-date-editor--daterange.el-input__inner {
      width: 100%;
    }

    .el-range-editor.el-input__inner {
      padding: 0 10px;
    }

    .el-range-input {
      line-height: 28px;
    }

    .el-range-separator {
      width: 30px;
      line-height: 25px;
    }
  }
}

</style>
